"use client";

import { useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export const InfoTooltip = ({
  content,
  children,
  asChild = false,
  openOnClick = false,
}: {
  content: React.ReactNode | string;
  children?: React.ReactNode;
  asChild?: boolean;
  openOnClick?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  return (
    <TooltipProvider>
      <Tooltip onOpenChange={setOpen} open={open}>
        <TooltipTrigger
          asChild={asChild}
          className={cn(
            "block max-w-full truncate",
            !children &&
              "flex h-[14px] w-[14px] items-center justify-center rounded-full bg-brand-violet text-white text-xs"
          )}
          onClick={(e) => {
            (openOnClick || isMobile) && setOpen(true);
            e.preventDefault();
          }}
          onMouseEnter={() => {
            if (openOnClick) {
              setOpen(false);
            }
          }}
        >
          {children ? children : "?"}
        </TooltipTrigger>
        <TooltipContent asChild>
          <div className="w-auto max-w-[340px] px-4! py-3! text-left">
            {content}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
